/*
 *
 * AdminAssessmentTool actions
 *
 */

import { createAction } from 'redux-actions';
import {
  PROCESSING,
  GET_ASSESSMENTS_DATA,
  GET_ASSESSMENTS_DATA_RESULT,
  SUBMIT_ASSESSMENT_TEST_DATA,
  GET_STORED_DATA,
  GET_STORED_DATA_RESULT,
} from './constants';

export const processing = createAction(PROCESSING);
export const getAssessmentsData = createAction(GET_ASSESSMENTS_DATA);
export const getAssessmentsDataResult = createAction(
  GET_ASSESSMENTS_DATA_RESULT,
);
export const submitAssessmentTestData = createAction(
  SUBMIT_ASSESSMENT_TEST_DATA,
);
export const getStoredData = createAction(GET_STORED_DATA);
export const getStoredDataResult = createAction(GET_STORED_DATA_RESULT);
